import { isDevMode } from "@angular/core";
import { EidosIconType } from "@eidos/models/core-constant.model";
import { IEidosEnvironment } from "@eidos/services/environment.interface";

export const EMPTY_CONFIG:IEidosEnvironment = {
  production: isDevMode(),
  baseUrl: window.location.origin,
  apiVersion:0,
  urlAPI: window.location.origin + '/mb',
  reportAPIUrl: window.location.origin + '/mb',
  reportInvokeAction: "/EidosWebDocumentViewer/Invoke",
  urlMessagingService: '',
  ExtendedFieldHeight: 59,
  ExtendedFieldPadding: 5,
  ExtendedFieldMargin: 5,
  landingPage: "entity-master",
  microsoftAuth: { enabled: false, authorizationUrl: 'general' },

  myBizLegacyConfiguration: {
    id: '-1',
    objectId: -1,
    source: 'mybiz',
    url: '/mb/webui/mybiz.html#',
    pattern: 'mybiz.html#',
    useToken: true,
    action: 'object',
    useLoader: false,
    actionInUrl: true,
    label: "MyBiz",
  },

  embeddedUrl: {
    id: '-2',
    objectId: 0,
    source: 'url',
    url: '',
    pattern: '',
    useToken: false,
    action: 'euri',
    useLoader: false,
    actionInUrl: true,
    label: "exturl"
  },

  loginConfiguration: {
    assetsPath: 'configurations/images/',
    logoName: 'logo.svg',
    wallpaperNames: 'background_1.jpg'
  },

  applicationTitle: 'Eidos',
  tokenOnHeader: false,

  notificationConfiguration: {
    enabled: false,
    pollingInterval: 60
  },

  logo: {
    iconType: EidosIconType.SVG,
    iconCode: 'logo-ak-travelgroup',
    iconSize: 4,
    inverseColor: true
  },

  defaultProfileBadge: {
    defaultBadgeColorPrimary: 'red',
    defaultBadgeColorSecondary: 'white'
  },

  externalAppsRoot: 'app',

  externalIcons: [],

  modules: [],

  formats: {
    defaultCurrency: 'USD',
    dateAndTime: 'dd/MM/yyyy HH:mm',
    dateFmt: 'dd/MM/yyyy',
    dateAndMonth: 'dd MMM',
    dateAndMonthAndYear: 'dd MMM yyyy',
    dateQueryParams: 'yyyy-MM-dd', // Format used for query date params

    dateStandardLocaleOpts: { locale: 'en'},

    currencies: {
      USD: "$",
      EUR: "€",
      GBP: "£",
      AUD: "A$",
      CAD: "C$",
    },
  }
};
